// Returns { prev, next } article objects given current slug and articles list
export function getPrevNext(currentSlug, articles) {
  if (!articles || articles.length === 0) return { prev: null, next: null };
  const currentIndex = articles.findIndex((a) => a.slug === currentSlug);
  const others = articles.filter((a) => a.slug !== currentSlug);

  // find articles that share at least one tag
  const current = articles[currentIndex];
  const matches = others.filter((a) => a.tags && current.tags && a.tags.some((t) => current.tags.includes(t)));

  const pickRandom = (arr, excludeSlugs = []) => {
    const pool = arr.filter((a) => !excludeSlugs.includes(a.slug));
    if (pool.length === 0) return null;
    return pool[Math.floor(Math.random() * pool.length)];
  };

  let prev = null;
  let next = null;

  if (matches.length >= 2) {
    prev = matches[0];
    next = matches[1];
  } else if (matches.length === 1) {
    prev = matches[0];
    next = pickRandom(others, [prev.slug]);
  } else {
    // no tag matches — pick two random distinct articles
    prev = pickRandom(others);
    next = pickRandom(others, [prev ? prev.slug : null]);
  }

  // fallback to neighbor-based selection if something missing
  if (!prev) prev = others[(currentIndex - 1 + others.length) % others.length] || null;
  if (!next) next = others[(currentIndex + 1) % others.length] || null;

  return { prev, next };
}
